import { EntGovernment } from "./handBooks/government";


export class EntPersonnelItem {
  id: number | null = null;
  periodStart: string  | null = null;
  periodEnd: string  | null = null;
  countPolitical: number  | null = null;
  countAdministrative: number  | null = null;
  countNonState: number  | null = null;
  countTop: number  | null = null;
  countMiddle: number  | null = null;
  countOther: number  | null = null;
  countArrived: number  | null = null;
  countDeparted: number  | null = null;
  government: EntGovernment  | null = null;
}
